import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Course = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="103" viewBox="0 0 91 103" width="91" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M82.55 76.06c-3.51 7.23-10.52 7.31-10.52 7.31s-.48 7.38-6.86 9.85C57 96.43 50.8 91.2 50.8 91.2s-4.94 5.27-13.42 2.32c-8.45-2.91-6.72-10.58-6.72-10.58s-9.4 0-11.99-8.38c-2.62-8.63 3.58-14.5 6.09-14.86-2.4-1.04-8.27-5.05-4.9-13.5 3.8-9.56 13.09-8.75 13.12-7.9 0 0-1.66-7.7 5.39-11.2 7.26-3.66 12.43 5.08 12.43 5.08s4.65-6.9 12.03-4.98c6.78 1.78 6.67 9.52 6.78 10.25.15-.7 10.55-.95 12.62 8.9C84.14 55.64 77 58.52 77 58.52s10.25 7.93 5.56 17.55Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M45.34 14.77s5.43-8.11 14.09-5.85c8.66 2.27 7.76 12.85 7.96 12.03s12.4-1.12 14.8 10.45c2.27 10.92-6.15 14.28-6.15 14.28s12.03 9.3 6.54 20.6c-4.12 8.5-12.31 8.58-12.31 8.58s-.6 8.64-8.08 11.56c-9.62 3.76-16.86-2.39-16.86-2.39V14.78z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M45.33 14.77v69.25s-5.8 6.2-15.76 2.73c-9.91-3.42-7.88-12.42-7.88-12.42s-11.04 0-14.07-9.83c-3.07-10.13 4.2-17.02 7.15-17.45-2.82-1.21-9.7-5.93-5.76-15.84C13.47 20 24.38 20.95 24.43 21.94c0 0-1.96-9.04 6.32-13.16 8.53-4.29 14.58 5.97 14.58 5.97z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m24.43 21.98 2.48 4.5" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M36.08 21.98c-5.21.34-10.86 4.33-12.98 10.92" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M14.75 47.05c7.73-2.8 11.97-.42 14.83 5.21" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M30.72 64.52c3.54 5.35 7.89 8.8 14.62 6.7" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M45.44 27.43c6.53-2.03 12.8 1.16 14.2 8.22" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M58.24 65.1c7.74.9 10.85 4.1 12.03 9.75" strokeWidth={strokeWidth} />
      <path d="M68.04 42.55v11.93H62.1V48.5h-5.97v5.97h-5.96V42.55z" fill={shades.white} />
    </svg>
  );
};
